module.exports = __webpack_public_path__ + "svg/am-icon-font.8cd9d9.svg";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/assets/fonts/am-icon-font.svg
 ** module id = 316
 ** module chunks = 12
 **/